/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwapListComponent } from './swap-list.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../../pipes/pipes.module';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '../tooltip/tooltip.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { VirtualListDropdownModule } from '../virtual-list-dropdown/virtual-list-dropdown.module';

@NgModule({
  declarations: [SwapListComponent],
  exports: [SwapListComponent],
  entryComponents: [SwapListComponent],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    FormsModule,
    PipesModule,
    ScrollingModule,
    ScrollbarModule,
    RouterModule,
    TranslateModule,
    TooltipModule,
    VirtualListDropdownModule
  ]
})
export class SwapListModule {}

export { SwapListComponent };
